import Vue from 'vue'
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import { LS } from "@/const"
import CodeSmsInput from '@/components/code-sms-input/code-sms-input.vue'
import FormWrapper from '@/components/form-wrapper/form-wrapper.vue'
import InputWrapper from '@/components/input-wrapper/input-wrapper.vue'
import { formatSeconds } from "@/helpers/date.js"

export default {
  name: 'FormSmsSecure',
  components: { CodeSmsInput, FormWrapper, InputWrapper },
  props: {
    api: { type: Function, default: null },
    apiResend: { type: Function, default: null },
    tempForm: { type: Object, default: {} },
  },
  data () {
    return {
      v$: useVuelidate(),
      errors: [
        {
          response: {
            status: 406,
            data: {
              message: this.$t('errors.codeSmsInvalid'),
            }
          }
        },
      ],
      countDown: LS.RESEND_SMS_SECS,
      invalidCodeSMS: false,
      timer: "",
      secureForm: {
        codeSMS: '',
      },
    }
  },
  emits: ['submit'],
  validations: {
    secureForm: {
      codeSMS: { required },
    },
  },
  computed: {
    formatedCountdown () {
      return formatSeconds(this.countDown)
    },
    form () {
      return { ...this.tempForm, ...this.secureForm }
    }
  },
  created: function () {
    this.countDownTimer()
  },
  methods: {
    countDownTimer () {
      if (this.countDown > 0) {
        this.timer = setTimeout(() => {
          this.countDown -= 1
          this.countDownTimer()
        }, 1000)
      }
    },
    submitCode () {
      Vue.nextTick(function () {
        const btnForm = document.getElementById('save-smssecure-btn-submit')
        btnForm.click(function (e) {
          // Prevent form submission which refreshes page
          e.preventDefault()
          return false
        })
      })
    },
    async onSendSms () {
      if (this.countDown === 0) {
        try {
          await this.apiResend(this.tempForm)
        } catch (error) {
          this.onError(error)
        } finally {
          clearTimeout(this.timer)
          this.countDown = LS.RESEND_SMS_SECS
          this.countDownTimer()
        }
      }
    },
    async onSubmitted () {
      this.$emit('submit')
    },
    onError (error) {
      console.error('[ERROR]', error)
      this.invalidCodeSMS = true
    },
  }
}
